<div class="customSlideStyle">
    <ngx-slick-carousel class="slick-slider slick-dotted" #slickModal="slick-carousel" [config]="slideConfig4">
        <div ngxSlickItem *ngFor="let airline of airlinesCarousel">
            <div class="slider-item" (click)="filterByAirline(airline.name);" [class.active]="airline.isChecked">
                <div>
                    <img style="width: 30px;" [src]="airline_logo + airline.code + '.svg'" /> &nbsp;&nbsp;
                    <div class="slide_right">
                    <span>{{ airline.name }}</span>&nbsp;
                   <span class="fligh_currency">{{ currency }}
                    {{ airline.price | number:'1.0-0' }}</span> 
                    </div>
                </div>
            </div>
        </div>
    </ngx-slick-carousel>
</div>